module.exports = __webpack_public_path__ + "static/media/gal11.e4ab273f.jpg";